import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'

export function MainScreen() {
  return (
    <>
      <h2 className="text-3xl font-bold mb-6 text-forest">Dashboard</h2>
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        <Card>
          <CardHeader>
            <CardTitle className="text-forest">Total Reports</CardTitle>
            <CardDescription>Number of reports available</CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-4xl font-bold text-forest">42</p>
          </CardContent>
        </Card>
        <Card>
          <CardHeader>
            <CardTitle className="text-forest">Recent Activity</CardTitle>
            <CardDescription>Last 7 days</CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-4xl font-bold text-forest">18</p>
          </CardContent>
        </Card>
        <Card>
          <CardHeader>
            <CardTitle className="text-forest">System Status</CardTitle>
            <CardDescription>All systems operational</CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-4xl font-bold text-green-600">OK</p>
          </CardContent>
        </Card>
      </div>
    </>
  )
}